import React from 'react'
import Projects from '../Components/Projects'
import { useEffect } from 'react'
import Project3 from '../Components/Projects3';

const Work = () => {
  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);
  return ( 
   <>

  <Project3/>
  
   </>
  )
}

export default Work
